import React from "react"

function Painting(props) {
    return (
        <div>
            <h3>What a beautiful painting.</h3>
            <div className="imageTextWrapper officePaintingWrapper">
                <img className="larryNotesImage officePainting" src="images/subway-painting.jpg" alt="oil painting of a crowded subway train" />
                <p className="bottomMiddleImageText paintingText">Subway, 1934<br /><em>Lily Furedi</em></p>
                <button className="paintingButton" onClick={props.handleClick} name="reveal safe"></button>
            </div>
        </div>
    )
}

export default Painting